function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// ----------------------------------------------------------------------------
// Web Component: iamCartItem <iam-cart-item>
// Extends: HTMLElement
// ----------------------------------------------------------------------------
// TODO
// ----------------------------------------------------------------------------
// Customization:
// - TODO
// ----------------------------------------------------------------------------
// Event Listeners:
// - `formValidation:init`            → Initializes form validation when the validation
//                                      class is ready
// - `cartForm:changed`            → Listens for when the form data changes
//                                      (option, selected variant, quantity, property)
//                                      to update the form validation state
// ----------------------------------------------------------------------------
// Event Triggers:
// - `cartForm:init`               → Triggers when the product form is ready
//                                      for modules/extensions to hook in
// - `cartForm:validation:init`    → Triggers when the form validation is initialized
//                                      (allowing modules to extend validation)
// - `cartForm:validation:changed` → Triggers when the form validation state changes
// - `cartForm:validation:success` → Triggers when the form validation is successful
// - `cartForm:validation:failed`  → Triggers when the form validation fails
// - `cartForm:changed`            → Triggers when the form data changes
//                                      (any of option, selected variant, quantity, property)
// - `cartForm:option:changed`     → Triggers when the form data changes (option)
// - `cartForm:variant:changed`    → Triggers when the form data changes (selected variant)
// - `cartForm:quantity:changed`   → Triggers when the form data changes (quantity)
// - `cartForm:property:changed`   → Triggers when the form data changes (property)
// - `cartForm:submitting`         → Triggers when the form is being submitted
// - `cartForm:submitted:success`  → Triggers when the form is successfully submitted
// - `cartForm:submitted:error`    → Triggers when the form submission fails
// ----------------------------------------------------------------------------
// Event Filters:
// - `cartForm:submitting:data`    → Allows filtering of the form data before submission
// ----------------------------------------------------------------------------
// Key Data Mutations:
// - Fetches product and custom data (product-form.graphql) and initializes the Shopify `cartForm`
// - Toggles form loading and error states based on child components and validation states
// - Submits the form over AJAX after validation
// ----------------------------------------------------------------------------
// Gotchas:
// - Relies on promises to fetch product and custom data, which may fail if the API calls do not resolve successfully.
// - Custom product data is only fetched if a query is provided.
// - Error messages are injected into the `.form__errors-container` element
//   and the form is marked with a `--error` class until resolved
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Helpers
import iamFormElement from 'scripts/classes/iamFormElement';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import Debug from 'scripts/libs/debug';
import { cart } from 'scripts/helpers/iamota-shopify-ajax';
import { formatMoney } from '@shopify/theme-currency';
import translate from 'scripts/helpers/iamota-translate';

// Styles
import './_cart-item.scss';

// Elements
import '../remove-from-cart-button/remove-from-cart-button';
import 'snippets/product-form/quantity-input/quantity-input';

// -------------------------------------
// Web Component
// -------------------------------------

class iamCartItem extends iamFormElement {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getCurrentProduct", () => {
      var _this$productData, _this$productData2;
      var currentProduct = (_this$productData = this.productData) === null || _this$productData === void 0 || (_this$productData = _this$productData.product) === null || _this$productData === void 0 ? void 0 : _this$productData.base;
      if (currentProduct && (_this$productData2 = this.productData) !== null && _this$productData2 !== void 0 && (_this$productData2 = _this$productData2.product) !== null && _this$productData2 !== void 0 && _this$productData2.custom) {
        var _this$productData3;
        currentProduct.custom = (_this$productData3 = this.productData) === null || _this$productData3 === void 0 || (_this$productData3 = _this$productData3.product) === null || _this$productData3 === void 0 ? void 0 : _this$productData3.custom;
      }
      return currentProduct;
    });
    _defineProperty(this, "getCurrentVariant", () => {
      var _this$productData4, _this$productData5;
      var currentVariant = (_this$productData4 = this.productData) === null || _this$productData4 === void 0 || (_this$productData4 = _this$productData4.variant) === null || _this$productData4 === void 0 ? void 0 : _this$productData4.base;
      if (currentVariant && (_this$productData5 = this.productData) !== null && _this$productData5 !== void 0 && (_this$productData5 = _this$productData5.variant) !== null && _this$productData5 !== void 0 && _this$productData5.custom) {
        var _this$productData6;
        currentVariant.custom = (_this$productData6 = this.productData) === null || _this$productData6 === void 0 || (_this$productData6 = _this$productData6.variant) === null || _this$productData6 === void 0 ? void 0 : _this$productData6.custom;
      }
      return currentVariant;
    });
    _defineProperty(this, "getCurrentOptions", () => {
      var _this$itemData;
      return (_this$itemData = this.itemData) === null || _this$itemData === void 0 ? void 0 : _this$itemData.options_with_values;
    });
    _defineProperty(this, "getCurrentProperties", () => {
      var _this$itemData2;
      return (_this$itemData2 = this.itemData) === null || _this$itemData2 === void 0 ? void 0 : _this$itemData2.properties;
    });
    _defineProperty(this, "getCurrentQuantity", () => {
      var _this$quantityInput;
      return (_this$quantityInput = this.quantityInput) === null || _this$quantityInput === void 0 ? void 0 : _this$quantityInput.value;
    });
    _defineProperty(this, "getCurrentData", () => {
      var currentData = {
        product: this.getCurrentProduct(),
        variant: this.getCurrentVariant(),
        options: this.getCurrentOptions(),
        properties: this.getCurrentProperties(),
        quantity: this.getCurrentQuantity()
      };
      return currentData;
    });
  }
  get namespace() {
    return "".concat(this.formName, ":items:item");
  }

  /**
   * Wait for the items component to be ready
   */
  onFormInit() {
    var _this$itemData3;
    iamotaEventHandler.subscribe('cartForm:items:init', this.onItemsInit.bind(this), {
      context: this.iamForm,
      source: "".concat("cart-item.js", "!").concat((_this$itemData3 = this.itemData) === null || _this$itemData3 === void 0 ? void 0 : _this$itemData3.variant_id)
    });
  }

  /**
   * Initialize the component when the cart items is initialized
   */
  onItemsInit() {
    var _this$dataset, _this$dataset2, _this$itemData4, _this$itemData5, _this$itemData6;
    // Prevent re-initialization during removal
    if (this.isInitialized) return;

    // Variables
    this.itemData = (_this$dataset = this.dataset) !== null && _this$dataset !== void 0 && _this$dataset.itemData ? JSON.parse(this.dataset.itemData) : null;
    this.productData = (_this$dataset2 = this.dataset) !== null && _this$dataset2 !== void 0 && _this$dataset2.productData ? JSON.parse(this.dataset.productData) : null;
    this.cartItems = this.closest('iam-cart-items');
    this.errorContainer = this.querySelector('.form__errors-container');
    this.quantityInput = this.querySelector('iam-quantity-input input');

    // Validation
    if (!this.validateRequiredAttributes(['itemData', 'productData', 'cartItems', 'errorContainer', 'quantityInput'])) return;

    // Bind Event Listeners
    iamotaEventHandler.subscribe('cart:modified', this.onCartModifed.bind(this));
    iamotaEventHandler.subscribe('cartForm:updates[]:changed', this.onQuantityChanged.bind(this), {
      context: this.quantityInput,
      source: "".concat("cart-item.js", "!").concat((_this$itemData4 = this.itemData) === null || _this$itemData4 === void 0 ? void 0 : _this$itemData4.variant_id)
    });

    // Debug
    iamotaEventHandler.trigger('cartForm:items:item:init', {
      cartItem: this
    }, {
      context: this
    });
    Debug.details("Cart Item Data: ".concat(Debug.colors.gray((_this$itemData5 = this.itemData) === null || _this$itemData5 === void 0 ? void 0 : _this$itemData5.title), " (").concat(Debug.colors.gray((_this$itemData6 = this.itemData) === null || _this$itemData6 === void 0 ? void 0 : _this$itemData6.variant_id), ") \u2193"), this.getCurrentData());

    // Revent double-initialization later
    this.isInitialized = true;
  }

  /**
   * Disconnected Callback
   */
  disconnectedCallback() {
    var _this$iamForm;
    (_this$iamForm = this.iamForm) === null || _this$iamForm === void 0 || (_this$iamForm = _this$iamForm.validator) === null || _this$iamForm === void 0 || _this$iamForm.removeField(this.quantityInput); // Remove field from validation
    this.iamForm.validateForm(); // Trigger form revalidation
    super.disconnectedCallback();
  }

  /**
   * Update Item Data if Cart is Modified
   */
  onCartModifed(cart) {
    // Update item data if cart is modified
    this.itemData = cart === null || cart === void 0 ? void 0 : cart.items.find(item => {
      var _this$itemData7;
      return item.key === ((_this$itemData7 = this.itemData) === null || _this$itemData7 === void 0 ? void 0 : _this$itemData7.key);
    });
    if (this.itemData) {
      this.syncLineTotal();
      this.syncQuantity();
    }
  }

  /**
   * Perform item removal
   */
  removeItem() {
    var _this = this;
    // Trigger item removal
    iamotaEventHandler.trigger('cartForm:items:item:remove:removing', {
      cartItem: this
    }, {
      context: this
    });

    // Cache the cart item data since we're about to delete it
    var cachedCartItem = null;
    try {
      cachedCartItem = {
        itemData: JSON.parse(JSON.stringify(this.itemData)),
        productData: JSON.parse(JSON.stringify(this.productData))
      };
    } catch (error) {
      // If we can't clone the cartItem, we can't reliably support undo
      Debug.error("Error cloning cartItem for cachedCartItem: ".concat(error.message), {
        error,
        cartItem: this,
        cachedCartItem
      });
    }
    cart.removeItem(this.itemData.key).then(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (cart) {
        // Trigger "removed" event before removing, otherwise the code gets eaten
        // Also, trigger this here to differentiate from an actual "remove" event vs. just the DOM being removed (might be a full cart UI resync)
        // await so that any handlers can deal with the data before it's nuked
        yield iamotaEventHandler.trigger('cartForm:items:item:remove:removed', {
          cart,
          cartItem: _this,
          cachedCartItem
        }, {
          context: _this
        });

        // Remove self from the DOM (triggers disconnectedCallback)
        _this.remove();
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()).catch(error => {
      iamotaEventHandler.trigger('cartForm:items:item:remove:error', {
        error,
        cartItem: this
      }, {
        context: this
      });
    });
  }

  /**
   * Handle quantity change
   */
  onQuantityChanged(_ref2) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var {
        value,
        control,
        _options
      } = _ref2;
      // Only react to your own quantity input
      if (control !== _this2.quantityInput) return;

      // Only react if the quantity input is not empty (they may have deleted the value to make changes)
      if (value === '') return;

      // Update quantity or remove item
      if (value === '') {
        // If empty value, set the value to the current quantity upon losing focus
        control.addEventListener('blur', () => {
          var _this2$itemData;
          _this2.quantityInput.value = (_this2$itemData = _this2.itemData) === null || _this2$itemData === void 0 ? void 0 : _this2$itemData.quantity;
        });
      } else if (value == 0) {
        _this2.removeItem();
      } else {
        _this2.setLoading(true);
        iamotaEventHandler.trigger('cartForm:items:item:quantity:changing', {
          quantity: value,
          cartItem: _this2
        }, {
          context: _this2
        });
        cart.changeQuantity(_this2.itemData.key, value).then(cart => {
          iamotaEventHandler.trigger('cartForm:items:item:quantity:changed', {
            cart,
            quantity: value,
            cartItem: _this2
          }, {
            context: _this2
          });
        }).catch(error => {
          var _error$context;
          _this2.setErrorState(((_error$context = error.context) === null || _error$context === void 0 ? void 0 : _error$context.data) || error);
          iamotaEventHandler.trigger('cartForm:items:item:quantity:error', {
            error,
            quantity: value,
            cartItem: _this2
          }, {
            context: _this2
          });
        }).finally(() => {
          _this2.setLoading(false);
        });
      }
    })();
  }
  syncLineTotal() {
    var lineTotalContainer = this.querySelector('.cart__item--total-wrapper .product__price');
    if (lineTotalContainer) {
      var _this$productData7, _this$itemData8, _this$itemData9;
      var compareAtPrice = (_this$productData7 = this.productData) === null || _this$productData7 === void 0 || (_this$productData7 = _this$productData7.variant) === null || _this$productData7 === void 0 || (_this$productData7 = _this$productData7.base) === null || _this$productData7 === void 0 ? void 0 : _this$productData7.compare_at_price;
      var originalLinePrice = compareAtPrice * ((_this$itemData8 = this.itemData) === null || _this$itemData8 === void 0 ? void 0 : _this$itemData8.quantity);
      var linePrice = (_this$itemData9 = this.itemData) === null || _this$itemData9 === void 0 ? void 0 : _this$itemData9.line_price;
      var priceHTML = '';
      if (originalLinePrice > linePrice) {
        priceHTML += "\n                    <s class=\"price__sale product__price--total-sale\">\n                        ".concat(formatMoney(originalLinePrice), "\n                    </s>\n                ");
      }
      priceHTML += "\n                <span class=\"cart__item--total-price price__original ".concat(originalLinePrice > linePrice ? 'price__original--sale' : '', "\">\n                    ").concat(formatMoney(linePrice), "\n                </span>\n            ");
      lineTotalContainer.innerHTML = priceHTML;
    }
  }
  syncQuantity() {
    var _this$itemData0;
    // Force-fix the Qty (in case they fall out of sync, e.g. Buy X Get Y edge cases when Shopify splits a line item in 2)
    if (this.quantityInput.value != ((_this$itemData0 = this.itemData) === null || _this$itemData0 === void 0 ? void 0 : _this$itemData0.quantity)) {
      var _this$itemData1;
      this.quantityInput.value = (_this$itemData1 = this.itemData) === null || _this$itemData1 === void 0 ? void 0 : _this$itemData1.quantity;
    }
  }
  /**
   * Set the error state for the item
   */
  setErrorState(error) {
    var _error$context2, _this$iamForm2;
    var errorMessage = typeof error === 'string' ? error : typeof (error === null || error === void 0 || (_error$context2 = error.context) === null || _error$context2 === void 0 ? void 0 : _error$context2.message) === 'string' ? error.context.message : typeof (error === null || error === void 0 ? void 0 : error.message) === 'string' ? error.message : typeof (error === null || error === void 0 ? void 0 : error.toString) === 'function' ? error.toString() : translate('An unexpected error occurred, please try refreshing the cart.', 'cartForm.error_unknown');
    var errorMap = new Map([[this.quantityInput, errorMessage]]);
    (_this$iamForm2 = this.iamForm) === null || _this$iamForm2 === void 0 || (_this$iamForm2 = _this$iamForm2.validator) === null || _this$iamForm2 === void 0 || _this$iamForm2.showErrors(errorMap);
    this.classList.toggle('--error', error);
  }
}
customElements.define('iam-cart-item', iamCartItem);